module.exports = __webpack_public_path__ + "img/guessp.aabf5424.svg";